import { useEffect, useState } from "react";
import ScopeService from "../../services/scope-service/ScopeService";
import { CustomizedCard } from "./styles";

import TBodyComponent from "./components/tbody-component/TBodyComponent";
import { Scope } from "../../models/Scope";
import AddButtonAsLink from "../../components/buttons/add-button/AddButtonAsLink";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";
import CustomizedTable from "../../components/table/CustomizedTable";
import DynamicBreadcrumb from "../../components/dynamic-breadcrumb/DynamicBreadcrumb";
import { useMountBreadCrumb } from "../../hooks/useMountBreadCrumb";
import axios from "axios";
import { GenericAlert } from "../../components/alert/GenericAlert";

const ScopesView = () => {
    const initialStatusAlert = {
        theme: "",
        message: "",
        isOpen: false
    };
    const [statusAlert, setStatusAlert] = useState(initialStatusAlert);
    const [scopes, setScopes] = useState<Scope[]>([]);
    const [isFetching, setIsFetching] = useState(false);
    const headTitles = ["Nome", "Descrição"];
    const { setBreadCrumb } = useMountBreadCrumb(); // Utilizado any por conta desse context ser JS puro

    useEffect(() => {
        getScopes();
    }, []);

    const getScopes = async () => {
        try {
            setIsFetching(true);
            const result = await ScopeService.findAll();
            setScopes(result);
            setIsFetching(false);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                setStatusAlert({
                    message:
                        error.response?.data?.message ||
                        "Houve um erro ao listar os escopos",
                    theme: "danger",
                    isOpen: true
                });
                return;
            }
            setStatusAlert({
                message:
                    "Houve um erro inesperado ao listar os escopos, tente novamente",
                theme: "danger",
                isOpen: true
            });
        }
    };

    const getBreadCrumbList = () => {
        const authBreadCrumbItem = {
            pathname: `/auth`,
            label: "Segurança"
        };
        const scopesBreadCrumbItem = {
            pathname: `/auth/scopes`,
            label: "Escopos"
        };
        const breadCrumbList = [authBreadCrumbItem, scopesBreadCrumbItem];
        return breadCrumbList;
    };

    const mountBreadCrumb = () => {
        const list = getBreadCrumbList();
        return <DynamicBreadcrumb breadCrumbList={list} />;
    };

    useEffect(() => {
        setBreadCrumb(mountBreadCrumb());
    }, []);

    const closeAlert = () => {
        setStatusAlert(initialStatusAlert);
    };

    return (
        <>
            <GenericAlert
                className="mb-3 cypreGenericAlert"
                dismissible={() => closeAlert()}
                open={statusAlert.isOpen}
                theme={statusAlert.theme}
            >
                {statusAlert.message}
            </GenericAlert>
            <CustomizedCard>
                <CustomizedCardHeader className={""} initialName={`Escopos`}>
                    <AddButtonAsLink
                        to="/auth/scopes/create"
                        id="TooltipNewScope"
                        label="Novo Escopo"
                    />
                </CustomizedCardHeader>
                {isFetching ? (
                    <div className="loading--container">
                        <div className="lds-dual-ring"></div>
                        <h1 className="loading--text">Carregando...</h1>
                    </div>
                ) : (
                    <>
                        <div style={{ padding: "0px 24px" }}>
                            <CustomizedTable headTitles={headTitles}>
                                <TBodyComponent scopes={scopes} />
                            </CustomizedTable>
                        </div>
                    </>
                )}
            </CustomizedCard>
        </>
    );
};

export default ScopesView;
